module.exports = __webpack_public_path__ + "media/super6_bpair.dc8f6d29.mp3";